"use server";

import { sdk } from "@/lib/medusa";
import medusaError from "@/src/lib/util/medusa-error";

export interface LocationsResponse {
  provinces: string[];
  municipalities: Record<string, string[]>;
}

export const getLocations = async () => {
  try {
    return await sdk.client.fetch<LocationsResponse>("/store/locations", {
      cache: "force-cache",
    });
  } catch (e) {
    console.error(e);
    return undefined;
  }
};

interface StateItem {
  name: string;
  iso_code: string;
  country_code: string;
}

interface CityItem {
  name: string;
  country_code: string;
  state_code: string;
}

export const listStates = async (countryCode: string) => {
  return sdk.client
    .fetch<{ states: StateItem[] }>(
      `/store/countries/${countryCode.toLowerCase()}/states`,
      {
        method: "GET",
        cache: "force-cache",
      }
    )
    .then(({ states }) => states)
    .catch(medusaError);
};

export const listCities = async (countryCode: string, stateCode: string) => {
  return sdk.client
    .fetch<{ cities: CityItem[] }>(
      `/store/countries/${countryCode.toLowerCase()}/states/${stateCode.toLowerCase()}/cities`,
      {
        method: "GET",
        cache: "force-cache",
      }
    )
    .then(({ cities }) => cities)
    .catch(medusaError);
};

export interface AvailableLocation {
  code: string;
  name: string;
  states: {
    iso_code: string;
    name: string;
  }[];
}

export const listAvailableLocations = async () => {
  return sdk.client
    .fetch<{ countries: AvailableLocation[] }>(
      `/store/stock-locations/available`,
      {
        method: "GET",
        // cache: "force-cache",
      }
    )
    .then(({ countries }) => countries)
    .catch(medusaError);
};

export interface ValidateLocationResponse {
  is_valid: boolean;
  has_any_active: boolean;
}

export const validateLocation = async (
  countryCode: string,
  province?: string,
  municipality?: string
): Promise<ValidateLocationResponse | undefined> => {
  try {
    const params = new URLSearchParams({ country_code: countryCode });
    if (province) params.append("province", province);
    if (municipality) params.append("municipality", municipality);
    return await sdk.client.fetch<ValidateLocationResponse>(
      `/store/locations/validate?${params.toString()}`,
      { cache: "no-store" }
    );
  } catch (e) {
    console.error(e);
    return undefined;
  }
};
